import { _get, _post, rootUrl } from "../Api";
import { toast } from "react-toastify";
import axios from "axios";

export function updateSupergroup(merchantId, supergroup, newData, oldValues) {
  return updateSupergroups(merchantId, [supergroup], [newData], [oldValues]).then((supergroups) => {
    return Promise.resolve(supergroups[0]);
  });
}

export function updateSupergroups(merchantId, supergroups, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in supergroups) {
    if (supergroups[i]) {
      data.push({
        supergroupId: supergroups[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        ...newData[i],
      });
    }
  }
  return _post(`/nova/v2/supergroups/${merchantId}/update`, data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}

export function updateSupergroupImage(merchantId, supergroupId, image) {
  let bodyFormData = new FormData();
  bodyFormData.set("merchantId", merchantId);
  bodyFormData.set("supergroupId", supergroupId);
  bodyFormData.set("image", image);
  return axios
    .post(rootUrl + "/nova/v2/supergroups/" + merchantId + "/supergroup/" + supergroupId + "/image", bodyFormData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      toast.success("Opgeslagen!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(response.data);
    })
    .catch((e) => {
      console.log(e);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
